@if (this.description) {
  <span nz-icon nzType="icons:info" nzTheme="outline" nz-tooltip
  [nzTooltipTitle]="this.description" class="tooltip" nzTooltipPlacement="topLeft"></span>
}